// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"db490d90e4d6e976208f","655":"a21df01d68740ffb2c57"}[chunkId] + ".js";
};